import Badge from "react-bootstrap/Badge";
import { snakeCase } from "lodash";
import React from "react";
import { Suggestion } from "../../../@types/SearchAutosuggest";
import { getLabelStringWithHighlightedPart } from "../utils";

interface Props {
  suggestion: Suggestion;
  inputValue: string;
}

const AutosuggestSuggestionLabel = ({ suggestion, inputValue }: Props) => {
  const { beforeHighlightedPart, highlightedPart, afterHighlightedPart } =
    getLabelStringWithHighlightedPart(suggestion.name, inputValue);

  return (
    <div className={"search-autosuggest__option"}>
      <div className={"search-autosuggest__option__title"}>
        {suggestion.isAlias && (
          <Badge
            bg="neutral"
            className="search__suggestion-badge"
            data-testid={snakeCase(
              `search_suggestion_item_${suggestion.name}_alias`
            )}
          >
            ALIAS
          </Badge>
        )}
        {beforeHighlightedPart}
        <strong>{highlightedPart}</strong>
        {afterHighlightedPart}
      </div>
      <div className={"search-autosuggest__option__help-text"}>
        {suggestion.helpText}
      </div>
    </div>
  );
};

export default AutosuggestSuggestionLabel;
